<template>
  <div v-if="hasContent" class="upsell-description">
    <div v-if="hasLabel" class="upsell-description__label">
      <ChoiceVanguardLabel :choice="choice" plain-text />
    </div>
    <div v-if="hasDetail" class="upsell-description__detail small-text">
      <ChoiceVanguardDescription :choice="choice" plain-text />
    </div>
  </div>
</template>

<script>
import ChoiceVanguardLabel from "@/components/choice/VanguardLabel.vue";
import ChoiceVanguardDescription from "@/components/choice/VanguardDescription.vue";
import { stripDecodedHtml } from "@/services/text";

export default {
  name: "ChoiceUpsellDescription",
  components: {
    ChoiceVanguardLabel,
    ChoiceVanguardDescription,
  },
  props: {
    choice: {
      type: Object,
    },
  },
  computed: {
    hasLabel() {
      return Boolean(stripDecodedHtml(this?.choice?.vanguardLabel));
    },
    hasDetail() {
      return Boolean(stripDecodedHtml(this?.choice?.vanguardDescription));
    },
    hasContent() {
      return this.hasLabel || this.hasDetail;
    },
  },
};
</script>
